var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Close Icon",
  stroke: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector 48",
  d: "m30.85 1.15-29.7 29.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 49",
  d: "M30.85 30.85 1.15 1.15"
}))));
export { SvgCloseIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkNsb3NlIEljb24iPgo8cGF0aCBpZD0iVmVjdG9yIDQ4IiBkPSJNMzAuODQ5NiAxLjE1MDc2TDEuMTUxMTIgMzAuODQ5MiIgc3Ryb2tlPSJ3aGl0ZSIvPgo8cGF0aCBpZD0iVmVjdG9yIDQ5IiBkPSJNMzAuODQ5NiAzMC44NDkyTDEuMTUxMTIgMS4xNTA3NiIgc3Ryb2tlPSJ3aGl0ZSIvPgo8L2c+Cjwvc3ZnPgo=";